import { Component, Input, OnInit } from '@angular/core';
import { DEFAULT_TITLE } from '../college-predictor.constant';

@Component({
  selector: 'app-college-predictor-listing',
  templateUrl: './college-predictor-listing.component.html',
  styleUrls: ['./college-predictor-listing.component.scss']
})
export class CollegePredictorListingComponent implements OnInit {
  public collegesList = [];
  public locations = [];
  @Input() branches = [];
  public courses = [];
  public selectedLocation = [];
  public selectedBranch = [];
  public selectedCourse = [];
  public searchValue = '';
  public sortType = DEFAULT_TITLE.HIGH_TO_LOW;
  public chanceLevel = {
    'High': 1,
    'Medium': 2,
    'Low': 3
  };
  @Input() examType;
  @Input() data;

  public get DEFAULT_TITLE() {
    return DEFAULT_TITLE;
  }
  constructor() { }

  ngOnInit(): void {
    if (this.data) {
      this.collegesList = this.data.all_branch;
      this.locations = this.data.location;
      this.courses = this.data.courseType;
    }
  }

  searchCollegeName(value) {
    this.searchValue = value;
  }

  searchLocation(value) {
    value = value.target.value.toLowerCase();
    this.locations = this.data.location.filter(location => location.name.toLowerCase().includes(value));
  }

  searchCourse(value) {
    value = value.target.value.toLowerCase();
    this.courses = this.data.courseType.filter(course => course.name.toLowerCase().includes(value));
  }

  searchBranch(value) {
    value = value.target.value.toLowerCase();
    this.branches = this.data.prefered_branch.filter(branch => branch.name.toLowerCase().includes(value));
  }

  selectLocation(isChecked, location) {
    isChecked = isChecked.target.checked;
    if (isChecked) {
      this.selectedLocation.push(location);
    } else {
      const index = this.selectedLocation.indexOf(location);
      if (index !== -1) {
        this.selectedLocation.splice(index, 1);
      }
    }
    this.filterCollege();
  }

  selectCourse(isChecked, course) {
    isChecked = isChecked.target.checked;
    if (isChecked) {
      this.selectedCourse.push(course);
    } else {
      const index = this.selectedCourse.indexOf(course);
      if (index !== -1) {
        this.selectedCourse.splice(index, 1);
      }
    }
    this.filterCollege()
  }

  selectBranch(isChecked, branch) {
    isChecked = isChecked.target.checked;
    if (isChecked) {
      this.selectedBranch.push(branch);
    } else {
      const index = this.selectedBranch.indexOf(branch);
      if (index !== -1) {
        this.selectedBranch.splice(index, 1);
      }
    }
    this.filterCollege()
  }

  filterCollege() {
    this.collegesList = this.data.all_branch.filter(college => {
      return ((this.selectedLocation.includes(college.location) || !this.selectedLocation.length) &&
        (this.selectedCourse.includes(college.courseType) || !this.selectedCourse.length) &&
        (this.selectedBranch.includes(college.branch) || !this.selectedBranch.length));
    });
  }

  applySort(type) {
    if (type === this.sortType) {
      return;
    }
    this.sortType = type;
    this.collegesList.sort((collegeA, collegeB) => {
      let difference;
      if (type.includes('rank')) {
        difference = collegeA.closingRank - collegeB.closingRank;
      } else {
        difference = this.chanceLevel[collegeA.chance] - this.chanceLevel[collegeB.chance];
      }
      return type.includes(DEFAULT_TITLE.HIGH_TO_LOW) ? -difference : difference;
    })
  }

}
